<meta charset="utf-8">
<style type="text/css">

* { padding:0; margin:0; line-height: 1.5; font-weight: 400; }
.top-nav-list, .main-nav {
	margin:0 auto;

    font-weight: bold ;
}
.header { background:#fff; }
.top-nav {
    background-color: #e5f5fb;
    border-bottom: 2px solid #009cd6;
}
.top-nav-list {
    display: flex;
    justify-content: flex-end;
    list-style-type: none;
    margin-bottom: 0;
    padding-left: 0;
}
.top-nav-list .list_item {
    font-weight: bold ;
    display: list-item;
	  padding: 0 1.1rem;
	  height:32px;
    text-align: -webkit-match-parent;
}
.top-nav-list .list_item .link {
    display: inline-block;
	color:#2f2f2f;
	padding: .35rem 0 .15rem;
	font-family: AvenirNextW06-Demi, sans-serif;
	font-size: .9rem;
	font-weight:bold;
    border-bottom: 1px solid transparent;
	text-decoration: none;
}
.top-nav-list .list_item:hover {
    background-color: #ccebf7;
	cursor:pointer;
}
.top-nav-list .list_item:hover .link {
    border-bottom: 1px solid #2f2f2f;
}
.main-nav{ padding:5px 0; display: flex; }


.main-nav .ituMainNavlogos #itu-secondary-logo {
    display: flex;
    align-items: center;
    margin-right: 0.5rem;
    padding-right: 0.75rem;
    border-right: 1px solid rgba(112, 112, 112, 0.3);
    font-size: 2rem;
  }

.nav-links-desk{
	list-style-type: none;
	margin-right: 200px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-links-desk .page-title{
  font-size:25px;
  font-weight: bold;	
  text-align: center; 
  /*  border: 1px solid red; */
  height: 100%;
  padding-top: 5px;

}


    /* fonts */
    @font-face {
      font-family: "AvenirNextW06-Demi";
      src: url("../assets/fonts/AvenirNextW06-Demi.woff2") format("woff2"),
        url("../assets/fonts/AvenirNextW06-Demi.woff") format("woff");
      font-weight: normal;
      font-style: normal;
      font-display: block;
    }
    @font-face {
      font-family: "Font Awesome 5 Pro";
      font-style: normal;
      font-weight: 400;
      font-display: block;
      src: url("./assets/fonts/fa-regular-400.eot");
      src: url("./assets/fonts/fa-regular-400.eot?#iefix") format("embedded-opentype"),
        url("./assets/fonts/fa-regular-400.woff2") format("woff2"),
        url("./assets/fonts/fa-regular-400.woff") format("woff"),
        url("./assets/fonts/fa-regular-400.ttf") format("truetype"),
        url("./assets/fonts/fa-regular-400.svg#fontawesome") format("svg");
    }
    header {
      background-color: #fff;
      z-index: 100;
    }
  
    /* nav wrapper */
    .nav-wrapper {
      background-color: #fff;
      position: relative;
      z-index: 10;
    }
    .nav-wrapper ul {
      list-style-type: none;
      margin-bottom: 0;
      padding-left: 0;
    }
    .nav-wrapper a,
    .nav-wrapper a:hover {
      color: #2f2f2f;
      text-decoration: none;
    }

  
    .nav-wrapper .top-nav {
      height: 38px;
    }
  
    /* container */
    .container {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
      max-width: 100%;
    }
  
    /* top nav */
    .top-nav .top-nav-list {
      padding-top: 5px;
    }
    .top-nav,
    .nav-links-desk {
      display: none;
    }
    .top-nav,
    .nav-links-desk {
      display: block;
      padding-left: 40px;
    }
    .top-nav {
      background-color: #e5f5fb;
      border-bottom: 2px solid #009cd6;

    }
    .top-nav-list {
      display: flex;
      justify-content: flex-end;
      padding-right: 25px;
      
    }

    /* main nav */
    .main-nav {
      border-bottom: 1px solid rgba(112, 112, 112, 0.3);
    }
    .main-nav__row {
      display: flex;
    }
    .main-nav__row {
      align-items: stretch;
    }
  
    /* ituMainNav */
    .main-nav .container .ituMainNavlogos i {
      display: block;
    }
    .main-nav .container .ituMainNavlogos {
      margin-left: 10px;
      display: flex;
      align-items: center;
    }
    .main-nav .container .ituMainNavlogos #itu-secondary-logo {
      display: flex;
      align-items: center;
      margin-right: 0.5rem;
      padding-right: 0.75rem;
      border-right: 1px solid rgba(112, 112, 112, 0.3);
      font-size: 2rem;
    }
       /* for wrc-23 logo 
    .main-nav .container .ituMainNavlogos #itu-primary-logo {
      display: flex;
      align-items: center;
    } 
    */
    .main-nav .container .ituMainNavlogos i {
      display: none;
      margin-right: 1rem;
      font-size: 1.6rem;
    }
  
    /* fa */
    .fa-bars:before {
      content: "\f0c9";
    }
    .fal {
      font-family: "Font Awesome 5 Pro";
      font-weight: 300;
    }
  </style>
  


<header class="header">

<nav class="nav-wrapper" id="wrapper-navbar" itemscope="" itemtype="http://schema.org/WebSite">
  
    <!-- level 1 (top) -->   
   <div class="top-nav">
        <ul class="top-nav-list">
            <li class="list_item"><a href="https://www.itu.int/en/about/Pages/default.aspx" class="link">About ITU</a></li>
            <li class="list_item"><a href="https://www.itu.int/en/ITU-R/Pages/default.aspx" class="link">Radiocommunication</a></li>
            <li class="list_item"><a href="https://www.itu.int/en/ITU-T/Pages/default.aspx" class="link">Standardization</a></li>
            <li class="list_item"><a href="https://www.itu.int/en/ITU-D/Pages/default.aspx" class="link">Development</a></li>
        </ul>
    </div>

    <!-- level 2 -->
    <div class="main-nav">
        <div class="container">
          <div class="main-nav__row">
            <!-- Logos -->
            <div class="ituMainNavlogos">
              <i id="mobilefullmenutrigger" class="fal fa-bars" />
  
              <a id="itu-secondary-logo" href="https://www.itu.int" target="_blank">
                <img src="./assets/img/ITU_logo_color.svg" alt="https://www.itu.int" height="48" />
              </a>
              <!-- <a id="itu-primary-logo" href="https://www.itu.int/wrc-23/" target="_blank">
                <img src="./assets/img/2023-wrc23-logo-h.png" alt="Event logo" height="48" />
              </a>-->
            </div>
            <!-- tabs -->
            <div class="nav-links-desk">
                   <p class="page-title">EPFD data and EPFD examination results</p>               
            </div>
          </div>
        </div>
      </div>
    </nav>
</header> 
